import { cme_kurs } from './Kurs'
import { backendUrl } from './constants';
import { mainVideo } from './Video'

// -- slides error handling
function errorHandling() {
    var result = true;

    // create error overlay
    var errorWindow = document.createElement('div');
    errorWindow.style =
        `position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 1000;
        padding: 1rem;`;

    // check if everything is here -> charts, slides, videos
    if (cme_kurs.allSlides.length !== cme_kurs.Video.length) {
        window.localStorage.clear();

        console.log("%cERROR: Die Anzahl folgender muss gleich sein:", 'color: red');
        console.log(`Anzahl Videos in "Kursinfo 1": `, cme_kurs.Video.length);
        console.log(`Anzahl Teile in "Charts": `, cme_kurs.allSlides.length);

        errorWindow.innerHTML =
            `<h1>FEHLER</h1>
            <div><p>Anzahl von Videos/Charts-Ordner/Slides stimmen nicht mit Anzahl der Kursteile (Parts) überein.</p></div>
            <div>
                <p>Stelle sicher dass: </p>
                <ul>
                    <span><strong>-> CMEassist</strong></span>
                    <li>Für jeden Teil in "Charts" genau ein Video-Element in "Kursinfo 1" definiert wurde</li>
                    <li>Jeder Teil  unter "Charts" angelegt wurde</li>
                </ul>
                <ul>
                    <span><strong>-> assets/charts/</strong></span>
                    <li>Es für jeden Teil einen Ordner "part_XX" in assets/charts/ gibt.</li>
                    <li>Ordner in assets/charts/ müssen folgende Syntax haben: "part_0X"</li>
                </ul>
                <ul>
                    <span><strong>Hinweis</strong></span>
                    <li>Eventuell Development-Server neu starten (npm start)</li>
                </ul>
            </div>
            <div><p>Für mehr Infos siehe Konsole</div>`;

        document.body.append(errorWindow);

        result = false;
    }

    return result;
}


//  --formate new Date() to string dd.mm.yyyy
const formatDateToString = (date) => {
    // if date is 0000-00-00
    if (isNaN(Date.parse(date))) return "xx.xx.xxxx";
    else {
        var MyDate = new Date(date);
        return ('0' + MyDate.getDate()).slice(-2) + '.'
            + ('0' + (MyDate.getMonth() + 1)).slice(-2) + '.'
            + MyDate.getFullYear();
    }
}


// -- go to specific course part
function jumpToCoursePart(part, setCourseIndex, setCurrentVideoTime) {
    // clear next-course-part-countdown
    clearInterval(mainVideo.countdownInterval);

    // pause video if not type powerpoint
    if (!cme_kurs.isPowerPoint) {
        mainVideo.video.pause();
        mainVideo.togglePlayPauseIcon();
        setCurrentVideoTime(0);
    }
    setTimeout(() => {
        // activate first thumbnail
        var firstThumbnail = document.querySelector('.single-thumbnail');
        if (firstThumbnail) {
            firstThumbnail.setAttribute('status', 'active');
            firstThumbnail.scrollIntoView();
        }

        // bugfix for ios <= 14
        mainVideo.videoLoadBugfix(0)
    }, 500);


    setCourseIndex(part);

    mainVideo.setDefaultScreen();
}


// -- get url parameter
function getURLParameter() {
    var urlString = window.location.search.substring(1);
    var urlParameter = new URLSearchParams(urlString);

    // create key-value object
    const result = {}
    for (const key of urlParameter.keys()) {
        result[key] = urlParameter.get(key);
    }

    return result;
}



/**
 *  Function for sending requests to backend
 * 
 * @param {String} method Request-Method (GET, POST, PATCH, ...)
 * @param {String} route Rest-Api-Route
 * @param {Object} body Request-Body sent to the backend
 * @returns on success -> database response / on failure -> false
 */
const sendRequest = async (method, route, body = undefined) => {

    // fetch info
    let url = `${backendUrl}${route}`;
    let options = {
        method: method,
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    // add body to request if neccesarry
    if (body) options.body = JSON.stringify(body);

    // fetch it
    return await fetch(url, options)
        .then(res => {
            // convert to json-object
            return res.json();
        })
        .then(data => {
            // SUCCESS
            // return data
            return data;
        })
        .catch(err => {
            // FAILURE
            console.log("Fehler:", err)
            return false;
        });
}

export { errorHandling, formatDateToString, jumpToCoursePart, getURLParameter, sendRequest }